import React, { useContext } from 'react';
import message from '~/utils/message';
import useOpenVoidItemPanel from '../VoidItemPanel';
import PageContext from '../../context';
import './style.css';
import { voidOrder } from '../../../../api';
import useNeedAuth from '../../../../../AuthorizePanel/hooks';
import BaseItemRow from '../BaseItemRow';
import clsx from 'clsx';
import { useCheckPermission } from '~/store/permission';
import { OrderItem } from '@restaurant/api';

const OrderDetailItemRow = ({
  item,
  batchIndex,
  itemIndex,
  orderId,
  disabled,
}: {
  item: OrderItem;
  batchIndex: number;
  itemIndex: number;
  orderId: string;
  disabled?: boolean;
}) => {
  const openVoidItemPanel = useOpenVoidItemPanel();
  const needAuth = useNeedAuth();
  const { refresh, paid } = useContext(PageContext);
  const checkPermission = useCheckPermission();

  const onClick = () => {
    if (disabled || paid) return;
    if (!checkPermission('order:u')) {
      message.error('Tidak ada izin akses untuk ubah item pesanan!');
      return;
    }

    openVoidItemPanel({
      item,
      onSubmit: (item) => {
        needAuth({
          permissionName: 'orderVoidAuthorization:r',
          entityId: orderId,
          onSubmit: ({ userId, actionToken }) => {
            voidOrder({
              level: 'item',
              orderId,
              voidBy: userId,
              batchIndex,
              itemIndex,
              item,
              actionToken,
            })
              .then(() => {
                message.warning('Berhasil void item');
                refresh();
              })
              .catch((e: any) => {
                message.error('Gagal void!');
              });
          },
        });
      },
    });
  };
  return (
    <div
      onClick={onClick}
      className={clsx('cursor-pointer', { 'bg-red-100': item.isChecked })}
    >
      <BaseItemRow item={item} />
    </div>
  );
};

export default OrderDetailItemRow;
